













































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { fetchMID } from './fetchMID';
import Confirmation from '@/components/Confirmation.vue';
import { AgGridVue } from 'ag-grid-vue';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    DatePicker,
    'app-confirmacion': Confirmation,
    'ag-grid-vue': AgGridVue,
  },
})
export default class EstadoIntegraciones extends ComponenteBase {
  [x: string]: any;
  dialogConfirmacionClose: boolean = false;
  filtro: any = '';
  ordesList: any[] = [];
  dateString: any = new Date();
  funcionalidad: Funcionalidades = Funcionalidades.EstadoIntegraciones;
  selectedItem: any;
  showTables = false;
  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Maximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    soloNumeros: (value: any) => {
      return value.match(/^[0-9]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      }
    },
  };
  formFields: {
    dateStart: any;
  } = {
    dateStart: {
      label: 'Fecha inicio',
      value: '',
      selectedValue: '',
    },
  };

  async GetEstadoIntegraciones() {
    let self = this;
    this.loadingService.showLoading();
    this.tablaDatos = [];
    this.ordesList = [];
    const formattedFechaInicio = moment(this.formFields.dateStart.value).format(
      'YYYY-MM-DD'
    );
    return fetchMID(
      {
        fini: formattedFechaInicio,
      },
      'mid_cliente/GetEstadoIntegraciones'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.visible = true;
          return data.data.data;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        console.error('Error:', error);
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async clearFilters() {
    this.visible = false;
    this.filtro = null;
    this.gridApi.setQuickFilter('');
    this.ordesList = null;
    this.gridApi.setRowData([]);
    this.formFields.dateStart.value = moment(
      this.dateString.getFullYear() +
        '-' +
        (this.dateString.getMonth() + 1).toString() +
        '-' +
        this.dateString.getDate()
    );
    console.log(this.filtro);
  }
  compras: any;
  delete: any;

  usuarioActivo: any = {};

  async showTable() {
    this.showTables = true;
    this.filtro = null;
    this.gridApi.setQuickFilter('');
    this.ordesList = (await this.GetEstadoIntegraciones()) || [];
    if (this.ordesList[0]['motorws'] != undefined) {
      const transformedData = this.ordesList.map(item => ({
        motorws: item.motorws,
        ok: item.ok,
        errores: item.errores,
        tiempo_promedio_reg_ok: item.tiempo_promedio_reg_ok,
        tiempo_promedio_reg_error: item.tiempo_promedio_reg_error,
        nombrewebservice: item.nombrewebservice,
        nombrelogico: item.nombrelogico,
        path_maquina: item.path_maquina,
        host_maquina: item.host_maquina,
      }));
      this.gridApi.setRowData(transformedData);
      this.gridApi.setDomLayout('autoHeight');
    } else {
      this.gridApi.setRowData([]);
    }
  }
  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
    this.showTable();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionConsultar, this.accionCrear];

  // Globales
  tabModel: string = 'tab-3';
  dialog: Boolean = false;
  search: string = '';

  gridOptions: GridOptions;

  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  // Componentes
  //showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  showModalAsignar: boolean = false;

  constructor() {
    super();

    this.columnDefs = [
      {
        headerName: 'Motores',
        field: 'motorws',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Ok',
        field: 'ok',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Errores',
        field: 'errores',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Tiempo Promedio Reg Ok',
        field: 'tiempo_promedio_reg_ok',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Tiempo Promedio Reg Error',
        field: 'tiempo_promedio_reg_error',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Nombre Web Service',
        field: 'nombrewebservice',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Nombre Lógico',
        field: 'nombrelogico',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Path Maquina',
        field: 'path_maquina',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
      {
        headerName: 'Host Maquina',
        field: 'host_maquina',
        sortable: true,
        resizable: true,
        minWidth: 80,
        lockPinned: true,
      },
    ];

    this.gridOptions = {
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      cacheBlockSize: 6, //Solución Paginación //Ordenamiento + Seleccion
      paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      serverSideDatasource: this.serverSide,
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.onGridReady,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
    };
  }

  mounted() {
    eventBus.changeTitlePage('Módulos');
    this.formFields.dateStart.value = moment(
      this.dateString.getFullYear() +
        '-' +
        (this.dateString.getMonth() + 1).toString() +
        '-' +
        this.dateString.getDate()
    );

    this.showTable();
  }

  created() {
    this.initialize();
  }

  onFilterTextBoxChanged() {
    clearInterval(this.intervalo);
    const self = this;
    this.intervalo = setInterval(function() {
      if (self.search.length >= 2) {
        self.gridApi.onFilterChanged();
      } else if (self.search.length === 0) {
        self.gridApi.setServerSideDatasource(self.serverSide);
      }
      clearInterval(self.intervalo);
    }, 500);
  }
  rutSelected: string = '';
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.EstadoIntegraciones) {
        if (data.action === Accion.Editar) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;
          this.editedIndex = data.id;
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = true;
            this.editedItem = data.cellRendererParams.data.proveedorrut;
          }
        }
      }
    });
  }

  beforeDestroy() {}

  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
    this.showModalAsignar = val;
    //this.obtenerMayor()+1;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    this.showModalNew = false;
  }
}
